module.exports = __webpack_public_path__ + "img/title.20455954.png";